<div class="d-block position-relative">
  <a (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </a>

  <div *ngIf="status==='loading'" class="d-flex flex-column align-items-center loader">
    <mat-spinner diameter="150" mode="indeterminate"></mat-spinner>
    <span>Transfer in <br>progress</span>
  </div>

  <div *ngIf="status==='showForm'">
    <h1>Send files</h1>
    <form [formGroup]="createShareFileForm" (submit)="submit()">

      <div [ngClass]="(badEmailInput || (createShareFileForm.controls.recipient_emails.touched && recipientEmails.length === 0 && !badEmailInput)) ? 'share-medix-input-chip-container error-field' : 'share-medix-input-chip-container'">
        <label class="sr-only" for="subject">recipient_emails</label>
        <div class="chip-section">
          <span *ngFor="let email of recipientEmails; let last=last;" [ngClass]="last && startDeletingByBackspace ? 'chip chip-selected' : 'chip'">{{email}}<img src="./assets/ui/svg/white/close.svg" (click)="deleteRecipientEmail(email)"/></span>
        </div>
        <div class="input-group">
          <input (keydown)="inputTyping($event)" (focusout)="emailFieldFocusOut()" type="text" id="recipient_emails" name="recipient_emails" placeholder="Recipient email" #recipienteemailsinput formControlName="recipient_emails" class="share-medix-input-group" autofocus autocomplete="off">
        </div>
      </div>

      <div class="share-medix-input-error" *ngIf="badEmailInput">Provided email is incorrect!</div>
      <div class="share-medix-input-error" *ngIf="createShareFileForm.controls.recipient_emails.touched && recipientEmails.length === 0 && !badEmailInput">Field email can't be empty.</div>

      <div class="share-medix-input-container">
        <label class="sr-only" for="password">password</label>
        <div class="input-group">
          <input type="password" id="password" placeholder="Set a Password (optional)" #passwordInput formControlName="password" class="share-medix-input-group">
        </div>
      </div>

      <div class="share-medix-input-container share-medix-select-container d-flex flex-row ">
        <label for="days_active">Expires after</label>
        <div class="input-group">
          <select id="days_active" name="days_active" formControlName="days_active" class="share-medix-input-group">
            <option *ngFor="let period of predefinedAvailablePeriods" [value]="period.days" [selected]="period.days===7">{{period.label}}</option>
          </select>
        </div>
      </div>

      <div class="share-medix-input-container">
        <label class="sr-only" for="subject">subject</label>
        <div class="input-group">
          <input type="text" id="subject" name="subject" placeholder="Subject (optional)" #subjectinput formControlName="subject" autocomplete="subject" class="share-medix-input-group">
        </div>
      </div>

      <div class="share-medix-input-container">
        <label class="sr-only" for="subject">message</label>
        <div class="input-group">
          <textarea type="text" id="message" name="message" placeholder="Message (optional)" #messageinput formControlName="message" autocomplete="message" class="share-medix-input-group share-medix-textarea" rows="5"></textarea>
        </div>
      </div>
      <button class="share-medix-btn" type="submit" [disabled]="recipientEmails.length < 1">Transfer</button>
    </form>
  </div>

  <div *ngIf="status==='done'" class="d-flex flex-column align-items-center done-section">
    <img [src]="'./assets/ui/svg/blue/icon-check-correct-animated.svg?v=' + doneTime">
    <h2>Done!</h2>
    <span>The transfer email has been sent. <br> Your transfer is available for {{selectedAvailablePeriodLabel}}.</span>
    <button class="share-medix-btn" mat-dialog-close="true">OK</button>
  </div>
</div>
